import { createClient } from '@supabase/supabase-js'

// Project credentials will be auto-injected during deployment
const SUPABASE_URL = 'https://placeholder.supabase.co'
const SUPABASE_ANON_KEY = 'placeholder-key'

// Create a mock client if credentials are not available
let supabase = null;

try {
  if (SUPABASE_URL !== 'https://placeholder.supabase.co' && SUPABASE_ANON_KEY !== 'placeholder-key') {
    supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true
      }
    });
  } else {
    // Mock Supabase client for development
    supabase = {
      from: () => ({
        select: () => ({ data: [], error: null }),
        insert: () => ({ data: [], error: null }),
        update: () => ({ data: [], error: null }),
        delete: () => ({ data: [], error: null }),
        eq: () => ({ data: [], error: null })
      }),
      auth: {
        signUp: () => ({ data: null, error: null }),
        signInWithPassword: () => ({ data: null, error: null }),
        signOut: () => ({ data: null, error: null }),
        getUser: () => ({ data: null, error: null })
      }
    };
  }
} catch (error) {
  console.warn('Supabase not configured, using mock client');
  // Mock Supabase client for development
  supabase = {
    from: () => ({
      select: () => Promise.resolve({ data: [], error: null }),
      insert: () => Promise.resolve({ data: [], error: null }),
      update: () => Promise.resolve({ data: [], error: null }),
      delete: () => Promise.resolve({ data: [], error: null }),
      eq: () => Promise.resolve({ data: [], error: null })
    }),
    auth: {
      signUp: () => Promise.resolve({ data: null, error: null }),
      signInWithPassword: () => Promise.resolve({ data: null, error: null }),
      signOut: () => Promise.resolve({ data: null, error: null }),
      getUser: () => Promise.resolve({ data: null, error: null })
    }
  };
}

export default supabase;